export const PRINTER_SETTING_KEY = 'SPL_PRINTER_ID';
export const HUB_SETTING_KEY = 'SPL_HUB_ID';
export const PARCEL_LABEL_PRINTER_SETTING_KEY = 'SPL_PARCEL_LABEL_PRINTER_ID';
export const PARCEL_LABEL_HUB_SETTING_KEY = 'SPL_PARCEL_LABEL_HUB_ID';
export const BARCODE_PRINTER_SETTING_KEY = 'SPL_BARCODE_PRINTER_ID';
export const BARCODE_HUB_SETTING_KEY = 'SPL_BARCODE_HUB_ID';
export const FULFILMENT_LOCATIONS_KEY = 'LCS_FULFILMENT_LOCATIONS';
export const FULFILMENT_PICK_UP_METHODS = ['af_pickup'];
